<template>
  <div class="footer_wrapper">
    <div
      style="width: 500px; margin: 0 auto; padding-top: 10px 0; color: white"
    >
      <img src="../../assets/imgs/备案图标.png" alt="" />
      <a
        target="_blank"
        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=50019002502497"
        style="
          display: inline-block;
          text-decoration: none;
          height: 20px;
          line-height: 20px;
          color: white;
        "
        ><img src="" style="float: left" />
        <p
          style="
            color: white;
            float: left;
            height: 20px;
            line-height: 20px;
            margin: 0px 0px 0px 5px;
            color: #939393;
          "
        >
          渝公网安备 50019002502497号 || 渝ICP备2020010005号-6
        </p></a
      >
    </div>

    <p>
      版权所有：环保信用.中国【公益平台】 || <a href="#/aboutUs">网站声明</a> ||
      <a href="#/aboutUs">关于我们</a>
    </p>
    <p>
      主办单位：重庆市民生生态环境研究院 ||  技术支持单位：重庆市民生生态环境研究院 || 服务电话：4000-816-106 ||
      您是第：<span
        style="cursor: pointer"
        class="visitorCount"
        @click="jumpToMap"
        >{{ visitorCount }}</span
      >
      位访问
    </p>

    <div class="floating_QR">
      <img src="../../assets/imgs/wechat_qr.jpg" alt="" />
      <img src="../../assets/imgs/apkQR.jpg" alt="" />
      <!-- <img src="../../assets/imgs/fs_qr.png" alt="" /> -->
    
      <!-- <p @click="jumpToOld()">切换旧版</p> -->
    </div>
    <div class="floating-logo">
      <img src="../../assets/imgs/header_logo.png" alt="" />
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapMutations: homeMutations, mapState: homeState } =
  createNamespacedHelpers("home");
export default {
  computed: {
    ...homeState(["visitorCount"]),
  },
  created() {
    const localCount = localStorage.getItem("visitorCount");
    if (localCount) {
      this.setVisitorCount(localCount);
    }
  },
  methods: {
    ...homeMutations(["setVisitorCount"]),
    jumpToOld() {
      window.open("http://221.10.90.154:8090", "_blank");
    },
    jumpToMap() {
      const routerData = this.$router.resolve("/visitorMap");
      window.open(routerData.href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/home/homeFooter.scss";
</style>